





import { wxConfigReady } from '@ivy/fts/weixin'
import { Component, Vue, Watch } from 'vue-property-decorator'
import config from './config'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component({})
export default class App extends Vue {
  async created() {
    await wxConfigReady()
    // 某些页面不需要登录
    // let noInit = ['/goodsView2', '/shop'].includes(this.$route.path)
    let noInit = ['/shop'].includes(this.$route.path)
    if (!noInit) {
      await env.init()
    }
    // await wxConfigReady()
    // this.$route.path !== '/goodsView2' && (await this.$store.login())
    // this.$axios.get('/api/m-course/sample/hello')
  }
}
